import {Injectable} from '@angular/core';

import {LogService} from './log.service';


@Injectable()
export class PerfService {
	constructor (
		private log: LogService
	) {}


	userActionStartTime: any;
	userActionStartLabel: any;

	lastUserActionEndTime: any;
	lastUserActionEndLabel: any;

	pageLoadEndTime: any;
	pageLoadEndLabel: any;


	markAppStart() {
		if (window && window.performance && window.performance.timing ) {
			// let timing = JSON.parse(JSON.stringify(window.performance.timing));
			// console.log(timing);

			// let loadEventEnd = window.performance.timing.loadEventEnd;
			// if (loadEventEnd === 0) {
			// 	// console.log('using Date.now() as loadEventEnd');
			// 	// https://www.w3.org/TR/navigation-timing/
			// 	loadEventEnd = Date.now();
			// }
			let loadEventEnd = Date.now();
			let pageLoadTime = loadEventEnd - window.performance.timing.navigationStart;

			// this.log.perf(`${pageLoadTime}, DOM loaded`);
			this.log.perf('DOM loaded', pageLoadTime);

			this.userActionStartTime = window.performance.timing.navigationStart;
			this.userActionStartLabel = 'page-load-start';
		} else {
			this.log.error('window.performance.timing not supported');
		}
	}


	markUserActionStart(userActionLabel: string) {
		this.userActionStartTime = Date.now();
		this.userActionStartLabel = userActionLabel;

		// if (window && window.performance) {
		// 	if (this.userActionStartLabel === 'page-load-start') {
		// 		if (this.lastUserActionEndTime) {
		// 			this.pageLoadEndTime = this.lastUserActionEndTime;
		// 			this.pageLoadEndLabel = 'page-load-end.' + this.lastUserActionEndLabel;
		// 		} else {
		// 			// this.pageLoadEndTime = window.performance.now();
		// 			this.pageLoadEndTime = Date.now();
		// 			this.pageLoadEndLabel = 'page-load-end';
		// 		}

		// 		let elasped = this.pageLoadEndTime - this.userActionStartTime;
		// 		let message = `${elasped}, ${this.userActionStartLabel}, ${this.pageLoadEndLabel}`;
		// 		this.log.perf(message);
		// 	}

		// 	// this.userActionStartTime = window.performance.now();
		// 	this.userActionStartTime = Date.now();
		// 	this.userActionStartLabel = userActionLabel;
		// }
	}


	markTabLoadEnd(endLabel: string) {
		this.lastUserActionEndTime = Date.now();
		this.lastUserActionEndLabel = endLabel;

		let elasped = this.lastUserActionEndTime - this.userActionStartTime;

		// let message = `${elasped}, ${this.userActionStartLabel}, ${this.lastUserActionEndLabel}`;
		// this.log.perf(message);
		let message = `${this.userActionStartLabel}, ${this.lastUserActionEndLabel}`;
		this.log.perf(message, elasped);

		// if (window && window.performance) {
		// 	// this.lastUserActionEndTime = window.performance.now();
		// 	this.lastUserActionEndTime = Date.now();
		// 	this.lastUserActionEndLabel = endLabel;

		// 	let elasped = this.lastUserActionEndTime - this.userActionStartTime;

		// 	let message = `${elasped}, ${this.userActionStartLabel}, ${this.lastUserActionEndLabel}`;
		// 	this.log.perf(message);
		// }
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/perf.service.ts